"use client";

import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import { fetchMemberActivitySummary } from "../../../../api/api";

const RecentEarnings = () => {
  const [Chart, setChart] = useState(null);
  const [range, setRange] = useState("weekly");

  const [categories, setCategories] = useState([]);
  const [series, setSeries] = useState([]);

  // Load ApexCharts dynamically
  useEffect(() => {
    import("react-apexcharts").then((mod) => {
      setChart(() => mod.default);
    });
  }, []);

  // Fetch member activity data
  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await fetchMemberActivitySummary(range);

        setCategories(data.categories || []);

        setSeries([
          {
            name: "Active Time",
            data: data.active || [],
          },
          {
            name: "Break Time",
            data: data.break || [],
          },
          {
            name: "Idle Time",
            data: data.idle || [],
          },
        ]);
      } catch (err) {
        console.error("Failed to fetch member activity summary", err);
        setCategories([]);
        setSeries([]);
      }
    };

    loadData();
  }, [range]);

  const options = {
    chart: {
      stacked: true,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        horizontal: false,
        columnWidth: "28px",
        borderRadiusApplication: "end",
      },
    },
    dataLabels: { enabled: false },
    colors: ["#605DFF", "#9CAAFF", "#DDE4FF"],
    xaxis: {
      categories,
      axisTicks: { show: false },
      axisBorder: { show: true, color: "#D5D9E2" },
      labels: {
        style: {
          colors: "#8695AA",
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => `${val}h`,
        style: {
          colors: "#64748B",
          fontSize: "12px",
        },
      },
      axisBorder: { show: true, color: "#D5D9E2" },
      axisTicks: { show: false },
    },
    legend: {
      show: true,
      position: "top",
      fontSize: "12px",
      horizontalAlign: "left",
      labels: { colors: "#64748B" },
      markers: {
        size: 7,
        shape: "diamond",
      },
    },
    fill: { opacity: 1 },
    grid: {
      strokeDashArray: 10,
      borderColor: "#ECEEF2",
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} hours`,
      },
    },
  };

  return (
    <Card className="bg-white border rounded-3 mb-4">
      <Card.Body className="p-4">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
          <h3 className="mb-0">Time Worked</h3>

          <Form.Select
            className="month-select form-control p-0 h-auto border-0 w-95"
            value={range}
            onChange={(e) => setRange(e.target.value)}
          >
            <option value="daily">This Day</option>
            <option value="weekly">This Week</option>
            <option value="monthly">This Month</option>
          </Form.Select>
        </div>

        <div
          style={{
            marginTop: "-10px",
            marginBottom: "-25px",
            marginLeft: "-15px",
            marginRight: "-5px",
          }}
        >
          {Chart && series.length > 0 && (
            <Chart
              options={options}
              series={series}
              type="bar"
              height={422}
            />
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default RecentEarnings;
